<!--
 * @Author: hongye
 * @Date: 2020-10-28 16:54:24
 * @LastEditTime: 2021-04-28 11:27:00
 * @Description: 
-->
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
          class="main-r_top_nav active"
      >在线文档</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">地址：使用接入方提供的URL</p>
          <p class="api_addr_info">请求方法：<span>POST</span></p>
          <p class="api_addr_info">数据类型：<span>X-WWW-FORM-URLENCODED </span></p>
          <p class="api_addr_info">响应类型：<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
  import onlineDoc from "../components/onlineDoc";
  export default {
    name: "settlementReturn",

    components: {onlineDoc},
    data() {
      return {
        onlineData: {
          //接口描述
          apiDesc: "接入方提供回传URL，极兔将通过接口下单的订单进行审核账单后，对订单进行回传账单信息",

          //参数描述  START
          postDataList: [
            //   请求头参数
            {
              title: 'Headers',
              value: [
                {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: "接入方在平台的api账户标识",},
                {name: "digest", type: "String", require: "Y", normal: "", describe: "签名字符串",},
                {name: "timestamp", type: "Number", require: "Y", normal: "", describe: "时间戳，毫秒",},
              ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title: "业务参数",
              value: [
                {name: "waybillNo", type: "String(30)", require: "Y", normal: "", describe: "运单编号"},
                {name: "totalFreight", type: "String(30)", require: "Y", normal: "", describe: "总运费"},
                {name: "packageChargeWeight", type: "String(30)", require: "Y", normal: "", describe: "计费重量"},
                {name: "insuredFee", type: "String(30)", require: "N", normal: "", describe: "保价费"},
                {name: "freight", type: "String(30)", require: "Y", normal: "", describe: "运费"},
                {name: "customerCode", type: "String(30)", require: "Y", normal: "J0086474299", describe: "客户编号"}
              ]
            }
          ],
          //参数描述  END
          //报文描述 start
          responseDataList: [

            //   响应参数
            {
              title: '响应参数',
              value: [
                {name: "code", type: "String", require: "Y", normal: "", describe: "返回码，见附录"},
                {name: "msg", type: "String", require: "Y", normal: "", describe: "描述"},
                {name: "data", type: "String", require: "Y", normal: "", describe: "业务数据"},
              ]
            }
          ],
          //请求示例
          requestCode: `Header：
apiAccount=1362
digest=U40e5sumorgd3YgZzU61Mw==
timestamp=1565238848921

Body：
bizContent={
  "customerCode": "J0086474299",
  "freight": 0,
  "insuredFee": 36,
  "packageChargeWeight": 3,
  "totalFreight": 36,
  "waybillNo": "UT0000273527404"
}
`,
          //返回示例
          responseCode: {
            'code': '1',
            'msg': 'success',
            'data':"SUCCESS"
        } ,
        errcodeJson: []
        }
      }
    },
    methods: {
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../css/apiTest.scss";
</style>
